export default "__VITE_ASSET__2_7b0hBU__"